import _regeneratorRuntime from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
import * as tslib_1 from "tslib";
/**
 * @class
 * Class representing CustomAuthenticationProvider
 * @extends AuthenticationProvider
 */

export var CustomAuthenticationProvider =
/*#__PURE__*/
function () {
  /**
   * @public
   * @constructor
   * Creates an instance of CustomAuthenticationProvider
   * @param {AuthProviderCallback} provider - An authProvider function
   * @returns An instance of CustomAuthenticationProvider
   */
  function CustomAuthenticationProvider(provider) {
    _classCallCheck(this, CustomAuthenticationProvider);

    this.provider = provider;
  }
  /**
   * @public
   * @async
   * To get the access token
   * @returns The promise that resolves to an access token
   */


  _createClass(CustomAuthenticationProvider, [{
    key: "getAccessToken",
    value: function getAccessToken() {
      return tslib_1.__awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _this.provider(function (error, accessToken) {
                    if (accessToken) {
                      resolve(accessToken);
                    } else {
                      reject(error);
                    }
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }]);

  return CustomAuthenticationProvider;
}();